import { defaultFetch } from "./baseApi";

export type RegisSystemType = {
    name: string;
};

export const getRegisSystems = () => {
    return defaultFetch<RegisSystemType[]>(`/v0/aws/secrets`);
}